import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getClientStatusDataByIPS } from '@/services/Smartlink/Reset'

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import MultipleCharts from '../charts/MultipleCharts.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetDialog',
  props: {
    finalIPS  : { type: Array<string>, required:true }
},
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t }  = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props

const params = {
    ips : props.finalIPS
}

const showGraphs = ref(true)
const allResetData = ref({
    allData : [],
    allName : []
})

async function getClientStatusByIP() {

    const allData = await getClientStatusDataByIPS(params)

    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs
        allResetData.value = allData.data
    }
}

onMounted(() => {
    getClientStatusByIP();
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", null, null, -1)),
    (showGraphs.value)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          class: _normalizeClass([_unref(xs)?'card-dialogs-graph-wop':'card-dialogs-graph', "mb-4"]),
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            (allResetData.value.allData.length > 0)
              ? (_openBlock(), _createBlock(MultipleCharts, {
                  key: 0,
                  "array-items": allResetData.value.allData,
                  "array-names": allResetData.value.allName,
                  title: 'Reset'
                }, null, 8, ["array-items", "array-names"]))
              : (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 1,
                  class: "text-center",
                  color: "transparent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Prog_circular)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})